import template from './index.jst';
import { View } from "backbone.marionette";
import { Model } from 'backbone';

export default class CoachDescriptionView extends View {
	get template() {
		return template;
	}

	initialize() {
		this.model = new Model({
			description: ''
		});

		this.subscription_type = 'season';
		this.description_key = 'trial_end';

		this.listenTo(this.model, 'change', this.render);
	}

	get description(){
		const descriptions = {
			trial: 'This trial will expire at the end of Round 1 or 14 days from your' +
				' registration, whichever is longer. Keep your edge by purchasing a Season' +
				' Pass or Monthly Pass at any time.',
			trial_end: `
				Coach is your premium Fantasy product fully integrated across the site and app 
				to provide you with the extra stats and info needed to improve your team! It 
				gives you the best chance at winning your league and possibly some great prizes!
			`,
			subscription: `Congratulations! You have signed up for a ${this.subscription_type} ` +
				`subscription of Coach. Enjoy using all the great ` +
				`Coach features to make your team a winner! Best of luck.`
		};

		return descriptions[this.description_key];
	}

	init({ has_assistant_coach, assistant_coach_plan, trial_end_in }) {
		this.description_key = 'trial_end';

		if (assistant_coach_plan === 'trial' && trial_end_in > 0) {
			this.description_key = 'trial';
		}
		else if (has_assistant_coach && assistant_coach_plan !== 'trial') {
			this.subscription_type = assistant_coach_plan;
			this.description_key = 'subscription';
		}

		this.model.set({
			description: this.description
		});
	}
}